export function anchorLinks() {
    (function() {
        /**
         * Anchor Links Bar Focus
         *
         * In-page anchor links are smooth-scrolled by scroll-animations.js,
         * which triggers `smoothscroll:end` on the target once the scroll
         * animation finishes. For links in the anchor links bar, wait for that
         * event, let the browser finish scrolling, then move keyboard focus to
         * the first interactive element inside the target section so keyboard
         * and screen reader users continue from where they visually landed.
         */
        const focusableSelector = [
            'a[href]',
            'button:not([disabled])',
            'input:not([disabled]):not([type="hidden"])',
            'select:not([disabled])',
            'textarea:not([disabled])',
            '[tabindex]:not([tabindex="-1"])'
        ].join(',');

        function firstFocusable($section) {
            return $section.find(focusableSelector).filter(function() {
                return $(this).is(':visible') && $(this).closest('[aria-hidden="true"], [hidden]').length === 0;
            }).first();
        }

        function focusSection($section) {
            const $target = firstFocusable($section);

            if ($target.length) {
                // preventScroll keeps the section where the user landed rather
                // than shifting the page to the focused element.
                $target[0].focus({ preventScroll: true });
                return;
            }

            // No interactive content: focus the section itself, as
            // skip-links.js does, so focus still moves into the region.
            if (!$section.is('[tabindex]')) {
                $section.attr('tabindex', '-1');
            }
            $section[0].focus({ preventScroll: true });
        }

        // The scroll animation's promise resolves when jQuery sets its final
        // scrollTop, but the html element has CSS scroll-behavior: smooth, so
        // the browser is still easing toward that value. Wait for scroll
        // events to go quiet before moving focus. If the page is already in
        // place (or reduced motion makes the jump instant) no scroll event
        // arrives and the short initial timer fires instead.
        function afterScrollSettles(callback) {
            let settled = false;
            let quietTimer;
            let maxTimer;

            const finish = function() {
                if (settled) return;
                settled = true;
                $(window).off('scroll', onScroll);
                clearTimeout(quietTimer);
                clearTimeout(maxTimer);
                callback();
            };

            const onScroll = function() {
                clearTimeout(quietTimer);
                quietTimer = setTimeout(finish, 100);
            };

            $(window).on('scroll', onScroll);
            quietTimer = setTimeout(finish, 150);
            maxTimer = setTimeout(finish, 1500);
        }

        $(document).on('click', '.anchor-link-nav a[href^="#"]', function() {
            const hash = $(this).attr('href');
            if (!hash || hash === '#') return;

            let $section;
            try {
                $section = $(hash);
            } catch (e) {
                return;
            }
            if (!$section.length) return;

            // Namespaced so a repeat click replaces any pending handler
            // instead of stacking a second one.
            $section
                .off('smoothscroll:end.anchorLinks')
                .one('smoothscroll:end.anchorLinks', function() {
                    afterScrollSettles(function() {
                        focusSection($section);
                    });
                });
        });
    })();
}
